<template>
  <modal @close="editTimes = false" small class="edit">
    <div slot="header"></div>
    <slot slot="body">
      <div class="fields-block">
        <div class="p-3" id="edit">
          <h3 class="border-bottom pb-2">{{ $t('payment.basket.edit') }}</h3>
          <div class="row my-3" v-if="!updated">
            <div class="col-md-6 field-col">
              <input-select
                v-model="arrivalTime"
                id="arrival" 
                :options="timeOptions"
                optionType="Array"
                label="payment.customer.arrival_time"
                @change="allowEditTimes"
              />
            </div>
            <div class="col-md-6 field-col">
              <input-select
                v-model="returnTime"
                id="return" 
                :options="timeOptions"
                optionType="Array"
                label="payment.customer.return_time"
                @change="allowEditTimes"
              />
            </div>
          </div>
          <div class="row" :class="{ 'text-center' : updated }">
            <div class="col-12 field-col my-3" v-if="editedProduct && !updated && !incorrectDate">
              <h6>
                {{ $t('payment.edit.price_difference') }}
                ({{ editedProduct.price >= product.price ? '+' : '-' }}{{ currency }}{{ Math.abs((product.price - editedProduct.price)).toFixed(2) }})
              </h6>
              <h6>{{ $t('payment.edit.new_price') }} <span class="price">{{ currency }}{{ editedProduct.price }}</span> ({{ $t('payment.edit.vehicles') }})</h6>
            </div>
            <div class="col-12 field-col mb-0" v-if="showNoResult">
              <h6 class="font-weight-normal text-danger"><strong>{{ product.park_name }} {{ $t('payment.edit.new_product') }}.</strong></h6>
            </div>
            <div class="col-12 field-col mb-3" v-if="incorrectDate">
              <h6 class="font-weight-normal text-danger"><strong>{{ $t('payment.edit.incorrect_date') }}.</strong></h6>
            </div>
            <div class="col-12 field-col my-3" v-if="updated">
              <h5 class="mb-2">{{ $t('payment.edit.updated') }}.</h5>
            </div>
            <div class="col-12 field-col mb-0">
              <button @click="cancel" class="btn btn-secondary remove mr-3 mb-3">{{ $t(`payment.edit.${updated ? 'return' : 'cancel'}`) }}</button>
              <button v-if="editedProduct && !showNoResult && !updated && !incorrectDate" @click="applyEdit" class="btn btn-secondary add">
                {{ $t('payment.edit.update_cart' ) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </slot>
  </modal>
</template>

<script>
import { sync, call, get } from "vuex-pathify";
import { InputSelect, Modal } from "@/components";
import mixins from "@/mixins";
import times from "@/utils/timeOptions";
import moment from "moment";

export default {
  name: "customer",
  mixins: [mixins.validate, mixins.load, mixins.globals],
  components: { InputSelect, Modal },
  computed: {
    quote: get("quote"),
    editTimes: sync("payment/editTimes"),
    editedProduct: sync("results/editedProduct"),
    cart: sync("cart/products"),
    product() {
      return this.cart.airportparking[0].product
    },
    result() {
      if(this.editedProduct.price === this.product.price) return 'not changed'
      return this.editedProduct.price > this.product.price ? 'increased' : 'decreased' 
    }
  },
  mounted() {
    this.arrivalTime = this.quote.timeA
    this.returnTime = this.quote.timeB

    this.$watch('arrivalTime',() => this.reQuote())
    this.$watch('returnTime',() => this.reQuote())
  },
  data() {
    return {
      timeOptions: times,
      showEditButton: false,
      arrivalTime: '12:00',
      returnTime: '12:00',
      showNoResult: false,
      updated: false,
      incorrectDate: false
    }
  },
  methods: {
    search: call("results/getModifiedResult"),
    reset: call("results/resetModify"),
    addToCart: call("cart/addToCart"),
    updateQuote: call("quote/updateQuote"),
    allowEditTimes() {
      this.$nextTick(() => {
        this.showEditButton = (this.quote.timeA !== this.arrivalTime || this.quote.timeB !== this.returnTime);
      })
    },
    applyEdit() {
      this.updateQuote({ ...this.quote, timeA: this.arrivalTime, timeB: this.returnTime }).then(() => {
        this.addToCart({ category: 'airportparking', ...this.editedProduct }).then(() => {

          this.fakeLoad(2000);

          setTimeout(() => {
            this.updated = true;
            this.editTimes = false;
            this.showNoResult = false;
            this.reset();
          }, 2000)

        });
      });
    },
    cancel() {
      this.editTimes = !this.editTimes;
      this.arrivalTime = this.quote.timeA;
      this.returnTime = this.quote.timeB;
      this.showNoResult = false;
      this.reset();
    },
    reQuote() {
      this.showNoResult = false;

      if(this.quote.dateA === this.quote.dateB) {
        if(moment(moment(this.returnTime, 'HH:mm')).isSameOrBefore(moment(this.arrivalTime, 'HH:mm'))) {
          return this.incorrectDate = true;
        }
      }

      this.incorrectDate = false;

      this.search({ timeA: this.arrivalTime, timeB: this.returnTime, product: this.product.park_id }).then(() => {
        if(!this.editedProduct) this.showNoResult = true;
      })
    },
  }
};
</script>